<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main box-panel shadow t-alignC max-w max-gs" id="page-content-main">
    <h2 class="mb-5">Select Your Account Type</h2>
    <div class="account-link-options">
      <a class="btn-link mx-3 mb-3" [routerLink]="['/ncp/creditcard']">Noncustodial Parent</a>
      <a class="btn-link mx-3 mb-3" [routerLink]="['/login']" [state]="{ creditCardMessage: 'To make a credit card payment, please login and select Credit Card Payment in the drop-down menu.' }">Employer</a>
    </div>
  </div>
</epay-page-content>
